var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useRef } from 'react';
import { isRef } from '../../utils/isRef';
import { useEventCallback } from '../useEventCallback';
/**
 * bind event when component mount and auto remove event when destroy.
 * can remove listener by call returned function or pass empty 'target'.
 *
 * @param target
 * listener will be removed when target is changed to null,
 * or rebinding to new element when `ref.current` change
 * @returns a method object
 * - listen() listen listener again, if that have listener, that will not listen again
 * - remove() remove listener
 * @example
 * ```ts
 * useEventListener(window, 'keyup', () => console.log('window key up'))
 * ```
 */
export function useEventListener(target) {
    var o = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        o[_i - 1] = arguments[_i];
    }
    var _a = __read(o, 3), key = _a[0], cb = _a[1], options = _a[2];
    var listener = useEventCallback(cb);
    var cancelRef = useRef(function () { });
    var bindRef = useRef(function () { });
    var currentRefElm = isRef(target) && target.current;
    useEffect(function () {
        if (!target)
            return;
        var elm = isRef(target) ? target.current : target;
        if (!elm) {
            return cancelRef.current;
        }
        bindRef.current = function () { return elm.addEventListener(key, listener, options); };
        cancelRef.current = function () { return elm.removeEventListener(key, listener, options); };
        bindRef.current();
        return cancelRef.current;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, currentRefElm]);
    return {
        listen: function () { return bindRef.current(); },
        remove: function () { return cancelRef.current(); },
    };
}
